export default __webpack_public_path__ + "static/img27h-71590790789710592d22ccf76e3caae0.jpg";